import { ProductAttributeSerializer } from "@app-contexts/dashboard/features/products/data/types";
import { GtagItemType } from "@shared/lib/analytics/types/analytics-types";
import Box from "@ui-kit/layout/Box/Box.web";
import useItemGroupProduct from "../hooks/useItemGroupProduct";
import type { BaseItemGroupDisplayProps } from "../ItemGroup.props";
import ItemGroupDisplay from "../ItemGroupDisplay/ItemGroupDisplay.web";
import ItemGroupSkeleton from "../ItemGroupSkeleton/ItemGroupSkeleton.web";

export default function ItemGroupProduct({
  productId,
  productAttribute,
  isParentLoading = false,
  updateItemTracking,
  productService,
  allowQuantityChange = true,
  minQuantityOverride,
  maxQuantityOverride,
  ...rest
}: {
  productId: number;
  productAttribute: number;
  updateItemTracking: ((input: GtagItemType) => void) | undefined;
  isParentLoading: boolean | undefined;
  allowQuantityChange?: boolean | undefined;
  minQuantityOverride?: number | null;
  maxQuantityOverride?: number | null;
} & Omit<BaseItemGroupDisplayProps, "name">): JSX.Element {
  const { productData, isFetching } = useItemGroupProduct(
    productId,
    productAttribute,
    productService,
    updateItemTracking,
    rest.id
  );
  const showSkeleton = isFetching || isParentLoading;
  const product = (
    productData?.product_attributes as ProductAttributeSerializer[]
  )?.find((pa) => productAttribute === pa.id);
  return (
    <Box width="100%">
      {showSkeleton && <ItemGroupProduct.Skeleton />}
      {!showSkeleton && productData && (
        <ItemGroupDisplay
          productService={productService}
          {...rest}
          name={productData.name}
          subtitle={product?.name}
          allowQuantityChange={allowQuantityChange}
          minQuantity={minQuantityOverride ?? undefined}
          maxQuantity={
            maxQuantityOverride ??
            Math.min(product?.purchase_limit || 0, product?.inventory || 0)
          }
        />
      )}
    </Box>
  );
}

ItemGroupProduct.Skeleton = ItemGroupSkeleton;
